import { useCallback, useState } from 'react';
import { isPhoneNative, isWeb } from '@helpers';
import { scale } from '@components/frame';
import { SAFE_TOP_INSET } from '@v2/components/imageHandling/constants';
import { DRAWING_BOTTOM_BAR_HEIGHT, DRAWING_TOP_BAR_HEIGHT, MOBILE_ANNOTATION_LIST_HEADER_HEIGHT } from '@v2/components/imageHandling/components/DrawingCanvas/constants';
import type { ManageDrawingCanvasLayoutResult } from '@v2/components/imageHandling/components/DrawingCanvas/types';

interface UseManageDrawingCanvasLayoutParams {
  /** Default desktop right-sidebar width — collapsed to 0 on phones where the strip replaces it. */
  annotationListWidth: number;
}

/**
 * Layout / chrome state for `<DrawingCanvas/>` — owns the phone strip toggle and exposes the
 * derived insets the component needs to position its drawing surface, top bar, sidebar, and
 * bottom toolbar.
 */
export const useManageDrawingCanvasLayout = ({ annotationListWidth }: UseManageDrawingCanvasLayoutParams): ManageDrawingCanvasLayoutResult => {
  const [isMobileListExpanded, setIsMobileListExpanded] = useState(false);

  const toggleMobileList = useCallback(() => setIsMobileListExpanded((v) => !v), []);

  const showMobileList = isPhoneNative;
  const safeTopInset = isWeb ? 0 : SAFE_TOP_INSET;
  const effectiveSidebarWidth = showMobileList ? 0 : annotationListWidth;
  const topBarHeight = scale(DRAWING_TOP_BAR_HEIGHT) + safeTopInset;
  const surfaceBottomInset = scale(DRAWING_BOTTOM_BAR_HEIGHT) + (showMobileList ? scale(MOBILE_ANNOTATION_LIST_HEADER_HEIGHT) : 0);

  return {
    showMobileList,
    effectiveSidebarWidth,
    topBarHeight,
    safeTopInset,
    surfaceBottomInset,
    isMobileListExpanded,
    toggleMobileList,
  };
};
